import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import HomeHero from '../components/Service/Home/Hero';
import HomeWhatWeDo from '../components/Service/Home/WhatWeDo';
import HomeOurTutors from '../components/Service/Home/OurTutors';
import HowItWorks from '../components/Service/Home/HowItWorks';
import Testimonials from '../components/organisms/Testimonials';
import StartNow from '../components/organisms/StartNow';

const Home = () => {
  const router = useRouter();
  const { locale: currentLocale } = router;
  const { t } = useTranslation('common');
  let backgroundClass = 'hero-background2';
  let backgroundImageUrl = '/images/hero2.jpg';
  if (currentLocale === 'ja' || currentLocale === 'tw') {
    backgroundClass = 'hero-background1';
    backgroundImageUrl = '/images/hero1.jpg';
  }
  return (
    <div>
      <Head>
        <title>{t('title.default')}</title>
        <meta name="description" content={t('description.default')} />
        <link rel="preload" href={backgroundImageUrl} as="image" />
      </Head>
      <HomeHero backgroundClass={backgroundClass} />
      <HomeWhatWeDo />
      <HomeOurTutors />
      <HowItWorks />
      <Testimonials />
      <StartNow />
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default Home;
